import Button from '@mui/material/Button';
import React, { useState } from 'react';

import { CustomTableEventModel } from '@/components/table/model/CutomTableEvent.model.ts';
import { customTableEventDispatcher } from '@/components/table/util/customTableEventDispatcher.util.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import { ProcessAddContactDialogCreateContactDialog } from '@/views/processesDetails/components/dialog/addContact/components/ProcessAddContactDialogCreateContactDialog.comp.tsx';

type Props = {
  isLoading: boolean;
};

export const ProcessAddContactDialogButton: React.FC<Props> = () => {
  const { t } = useTranslationWithPrefix('views.processesUpdate.dialog.addContact');
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleCreateCustomer = () => {
    setIsDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  const handleContactCreated = (contactName: string) => {
    customTableEventDispatcher(CustomTableEventModel.REFRESH, {
      fullTextSearchInput: contactName,
    });
  };

  return (
    <>
      <Button onClick={handleCreateCustomer}>{t('button.createContact')}</Button>
      {isDialogOpen && (
        <ProcessAddContactDialogCreateContactDialog
          onClose={handleCloseDialog}
          onCreated={handleContactCreated}
        />
      )}
    </>
  );
};
